import React,{useState} from "react";
import Header from "../../layoutUser/header/header";
import Sidebar from "../../layoutUser/sidebar/sidebar";
import StylesCenter from "../../layoutUser/center/styles";
import "../../assets/styles/styleUser.css";
import useMediaQuery from "@mui/material/useMediaQuery";
function Styles() {
  const [searchStyle, setSearchStyle] = useState(''); 
  const isSmallScreen = useMediaQuery("(max-width: 600px)");
  const handleSearch = (term) => {
    setSearchStyle(term);
  };
  return (
    <div className="container">
     <Header placeholder={'Search style...'} isHomePage={false} onSearch={handleSearch}/>
     {
        isSmallScreen?null: <Sidebar />
      }
      <StylesCenter searchStyle={searchStyle} />
    </div>
  );
}

export default Styles;
